const goToSupportURL = whatsAppOptions => {
  const whatsAppURL = `/whatsapp?${Object.keys(whatsAppOptions)
    .map(key => `${key}=${encodeURIComponent(whatsAppOptions[key])}`)
    .join('&')}`;

  window.open(whatsAppURL, '_blank', 'noopener noreferrer');
};

export default goToSupportURL;
